import { TaskStatus } from '../Types/TaskStatus';
/**
 * 创建默认的运行时状态
 */
export function createDefaultRuntimeState() {
    return {
        status: TaskStatus.Invalid,
        currentChildIndex: 0
    };
}
//# sourceMappingURL=BehaviorTreeData.js.map